import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import IntakeForm from "./pages/IntakeForm";
import PublicIntakeForm from "./pages/PublicIntakeForm";
import AdminDashboard from "./pages/AdminDashboard";
import DigitalResources from "./pages/DigitalResources";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/intake-form/:bookingId" element={<IntakeForm />} />
          <Route path="/intake" element={<PublicIntakeForm />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/resources" element={<DigitalResources />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
